import React from "react";
import styles from "./Footer.module.scss";
import cn from "classnames";
import {Container, Row, Col} from "react-bootstrap";
import SocialMedia from "./SocialMedia";
import Contacts from "./Contacts";
import Copyright from "./Copyright";
import Docs from "./Docs";
import LazyImage from "../LazyImage/LazyImage";

const Footer: React.FC = () => {
    return (
        <div className={styles.footer}>
            <div className={cn(styles.footerHr, "d-flex d-md-none")}>
                <Container>
                    <SocialMedia/>
                </Container>
            </div>

            <div className={styles.footerHr}>
                <Container>
                    <div className={styles.footerHrItem}>
                        <LazyImage className={styles.footerLogo}
                                   src="./assets/images/logos/elsLogo.svg"
                                   alt="ELS Group"
                        />
                        <Contacts/>
                    </div>
                </Container>
            </div>
            <Container>
                <div className={styles.footerRow}>
                    <Row>
                        <Col md={{span: 4, order: 1}}>
                            <SocialMedia className="d-none d-md-flex"/>
                        </Col>
                        <Col md={{span: 8, order: 0}}>
                            <Copyright/>
                        </Col>
                        <Col md={{span: 11, order: 2}}>
                            <Docs/>
                        </Col>
                        <Col md={{span: 1, order: 3}}>
                            <div className={styles.ageRest}>
                                18+
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    )
}

export default Footer;